import React, {useContext} from 'react';

import NeighborhoodScreen from '..';
import {TModal} from "../../../../../types/common.type";
import {locationNamespace} from "../../../../../types/location.namespace";
import {useQuery, UseQueryResult} from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import Context from "../../../../../context";
import successHandler from "../../../../../utils/successHandler";

const NeighborhoodContainer: React.FC = (): React.ReactElement => {

  const { userInfo } = useContext(Context.UserScreen);

  const getProvince = useQuery(
    ['companyProvince'],
    () => api.get.common.searchProvince({ limit: 50 })
  );

  const provinceFiltered4Company = getProvince?.data?.result && getProvince?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.province?.includes(item?._id)
  );

  const getCity = useQuery(
    ['companyCities'],
    () => api.get.common.searchCity({limit: 50, province: provinceFiltered4Company[0]?._id}),
    {enabled: provinceFiltered4Company?.length >= 1}
  );

  const cityFiltered4Company = getCity?.data?.result && getCity?.data.result.docs?.filter((item: any) =>
    userInfo?.companyInformation?.city?.includes(item?._id)
  );

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<locationNamespace.neighborhood.index | undefined>(undefined);
  const [requestNeighborhood , setRequestNeighborhood ] = React.useState<locationNamespace.neighborhood.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCities: UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.locationGetNeighborhood, requestNeighborhood],
    () => api.get.common.searchNeighborhood({...requestNeighborhood, city: cityFiltered4Company[0]._id}),
    {enabled: cityFiltered4Company?.length >= 1}
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.neighborhood.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createNeighborhood(event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.neighborhood.update): Promise<void> {
    setIsLoading(true);
    if (!selectedNeighborhood) return;
    const result = await api.patch.administrator.updateNeighborhood(selectedNeighborhood?._id, event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.Neighborhood.Provider value={{
      showModal           ,
      isLoading           ,
      requestNeighborhood ,
      selectedNeighborhood,
      setShowModal           ,
      createFunction         ,
      updateFunction         ,
      setRequestNeighborhood ,
      setSelectedNeighborhood,
    }}>
      <NeighborhoodScreen rqData={getCities} />
    </Context.Location.Neighborhood.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default NeighborhoodContainer;
